import { useCallback } from 'react'
import { HandleUserNotificationCreatedTask } from '../Tasks/HandleUserNotificationCreatedTask'

/**
 * Public API: callbacks for handling realtime publications from Centrifugo
 * that mutate notification state. Returned handlers are stable across renders.
 */
export const useNotificationRealtime = () => {
    const onUserNotificationCreated = useCallback(() => {
        HandleUserNotificationCreatedTask()
    }, [])

    return { onUserNotificationCreated }
}
